import axios, { AxiosInstance, AxiosResponse } from "axios";
import { ChurnCallUpdateRequest } from "../../../@Types/DTO/ChurnCallUpdateRequest/ChurnCallUpdateBody";
import { ChurnCallUpdateResponse } from "../../../@Types/DRO/ChurnApiResponse/ChurnCallUpdateResponse";



export class ChurnCallUpdateApi {
    public static api = new ChurnCallUpdateApi();
    private instance: AxiosInstance;

    constructor() {
        this.instance = axios.create({
            baseURL: process.env.REACT_APP_CHURN_BASE_URL,
            headers: {
                "Content-Type": "application/json",
            },
        });
    }

    getToken() {
        return localStorage.getItem("token");
    }

    async updateChurnCall(pred_id: number, data: ChurnCallUpdateRequest): Promise<ChurnCallUpdateResponse> {
        try {
            const response: AxiosResponse<ChurnCallUpdateResponse> = await this.instance.put(`/churn-call-update/${pred_id}`, data, {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error updating churn call", error);
            throw error;
        }
    }
}